import { Parameter } from "@/backend/models/parameter";
import { I18n } from "@/i18n/I18n";
import { ParameterInputType } from "@/types/parameterTypes";

export function parameterTypeLabel(parameter: Parameter) {
  const INPUT_LABEL_MAP = {
    [ParameterInputType.LIST]: ` ${I18n.get('list')}`,
    [ParameterInputType.MULTIPLE_CHOICE]: ` ${I18n.get('multipleChoice')}`,
    [ParameterInputType.SINGLE_CHOICE]: ` ${I18n.get('singleChoice')}`,
    [ParameterInputType.FREE_FORM]: '',
    [ParameterInputType.TABLE]: ` ${I18n.get('table')}`,
  };
  return `(${I18n.get(parameter.fieldType)}${INPUT_LABEL_MAP[parameter.inputType]})`;
}